﻿import type { License } from 'apis/TransactionApi';
import { Country } from 'apis/CountryApi';

export function mapToRecordObject<T extends Record<string, any>, U extends keyof T>(arr: T[], key: U) {

    const recordObject = {} as Record<T[U], T>;
    arr.forEach(item => (recordObject[item[key]] = item));
    return recordObject;

}

export function removeUndefined<T>(arr: (T | undefined)[]) {

    return arr.filter((value): value is T => value !== undefined);

}

export function getByIdValue<T, U extends keyof T>(arr: T[], idName: U, idValue: T[U]) {

    return arr.filter(item => item[idName] === idValue)[0];

}

export function compareArray(arr1: number[], arr2: number[]) {

    arr1.sort();
    arr2.sort();
    return arr1 + '' == arr2 + '';

}

export const mapLicensesToGetOrderDetails = (licenses: License[], inactiveOrderIds: number[]) => {

    const listOfInactiveOrders: License[] = [];
    for (let i = 0; i < inactiveOrderIds.length; i++) {

        const orderDetails = licenses.find(order => order.OrderId === inactiveOrderIds[i]);
        if (orderDetails) {

            listOfInactiveOrders.push(orderDetails);

        }

    }
    return listOfInactiveOrders;

};

export const setCountriesWithUnitedStateAtTop = (countries: Country[]) => countries.sort((a, b) => {

    if (a.Name === 'United States of America' || a.Id === 1) return -1;
    if (b.Name === 'United States of America' || b.Id === 1) return 1;
    return 0;

});

export const filterDataBySearchTerm = <T>(searchTerm: string, arr: T[]) => {

    if (searchTerm === '') {

        return arr;

    } else if (arr.length > 0) {

        const rowKeys = Object.keys(arr[0] as any);
        const filteredItems: T[] = arr.filter(item => {

            for (const key of rowKeys) {

                if (
                    (item as any)[key] !== null &&
                    (item as any)[key] !== undefined &&
                    typeof (item as any)[key] !== 'object' &&
                    (item as any)[key].toString().toUpperCase().includes(searchTerm.trim().toUpperCase())
                ) {

                    return item;

                }

            }

        });
        return filteredItems;

    }
    return [];

};

export const filterOutNonExistentOrderIds = (pieceOfContentOrderIds: number[], activeOrderHistoryLicenses: License[]) => {

    if (pieceOfContentOrderIds === undefined) {

        return [];

    }
    return [...new Set(pieceOfContentOrderIds.filter(id => activeOrderHistoryLicenses.some(license => license.OrderId === id)
    ))];

};
